/* eslint-disable */
import store from "@/store";
import axios from "axios";
import traverse from "traverse";

export function errorHandling(error) {
  let handleErrorData = null;
  if (error.response) {
    handleErrorData = error.response.data;
  } else if (error.request) {
    handleErrorData = error.request.data;
  } else {
    store.dispatch("showAlertError", {
      title: "Koneksi terputus",
      message: "Cek koneksi dan segarkan kembali halaman anda !",
    });
    return;
  }

  const errorDetails = traverse(handleErrorData).reduce(function(arr, data) {
    if (this.isLeaf) arr.push(data);
    return arr;
  }, []);

  if (errorDetails[0].includes("html")) {
    return;
  }

  if (errorDetails.length !== 0) {
    store.dispatch("showAlertError", {
      title: "Koneksi terputus",
      message: errorDetails[0],
    });
  } else {
    store.dispatch("showAlertError", {
      title: "Kesalahan Permintaan",
      message: "Silahkan coba kembali !",
    });
  }
}

class User {
  static getInfo(env, token) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/auth/users/me/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ status, data }) => {
          if (status == 200) {
            store.commit("setUserInfo", {
              id: data["id"],
              username: data["username"],
              firstName: data["first_name"],
              lastName: data["last_name"],
              email: data["email"],
              whatsappNumber: data["whatsapp_number"],
            });
            resolve(data);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getRole(env, token) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/auth/users/me/roles/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ status, data }) => {
          if (status == 200) {
            if (data.roles.length != 0) {
              store.commit("setUserRole", {
                role: data.roles,
              });
            } else {
              store.commit("setUserRole", {
                role: [
                  {
                    role_id: 5,
                    description: "",
                  },
                ],
              });
            }
            resolve(data);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getLatestPeriod(env) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/tahfidz/periods/latest/")
        .then(({ data }) => {
          if (data.latest_opened != null && data.latest_opened.length != 0) {
            store.commit("setLatestOpened", {
              latest_opened: data.latest_opened,
            });
          }
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getPeriods(env, termId) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + `/api/tahfidz/terms/${termId}/periods/`)
        .then(({ data }) => {
          store.commit("setPeriods", { value: data });
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static refreshJWTToken(env, token) {
    return new Promise((resolve, reject) => {
      axios
        .post(env + "/api/auth/jwt/refresh/", {
          refresh: token,
        })
        .then(({ data }) => {
          store.commit("setAccessToken", { value: data.access });
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static sendProgramRegistrationForm(env, token, periodId, term, form) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const referralNames = [form.referralName1, form.referralName2] + "";
      formData.append("term", term);
      formData.append("user", store.getters.getUserId);
      formData.append("age", form.age);
      formData.append("gender", form.gender);
      formData.append("domicile", form.domicile);
      formData.append("recording", form.recording);
      formData.append("juz_target_number", form.juzTargetNumber);
      formData.append("juz_number_memorized", form.juzNumberMemorized);
      formData.append("tahsin_experience", form.tahsinExperience);
      formData.append("pilihan_infaq", form.infaqOptionNumber);
      formData.append("referral_names", referralNames);
      formData.append("selection_period", periodId);
      formData.append("motivation", form.motivation);
      formData.append("program_reference", form.programInfoReference);
      axios
        .post(env + "/api/tahfidz/selections/" + periodId + "/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "JWT " + token,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getAnnouncementReport(env, token, periodId) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/tahfidz/selections/" + periodId + "/me/status/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          store.commit("setHarakatScore", {
            value: data["registration_status"]["harakat_mistake"],
          });
          store.commit("setMadScore", {
            value: data["registration_status"]["mad_mistake"],
          });
          store.commit("setGunnahScore", {
            value: data["registration_status"]["gunnah_mistake"],
          });
          store.commit("setPassed", {
            value: data["registration_status"]["is_passed"],
          });
          store.commit("setTahsinLevel", {
            value: data["registration_status"]["tahsin_level"],
          });
          store.commit("setEvaluator", {
            value: data["registration_status"]["evaluator_name"],
          });
          store.commit("setNote", {
            value: data["registration_status"]["note"],
          });
          store.commit("setAnnouncementAvailable", { value: true });
          resolve(data);
        })
        .catch(() => {});
    });
  }

  static getActivation(env, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(env + "/api/auth/users/activation/", {
          uid: params.uid,
          token: params.token,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static signUp(env, form) {
    return new Promise((resolve, reject) => {
      const nameArr = form.fullname.split(" ");
      const firstName = nameArr[0];
      const lastName = nameArr.slice(1, nameArr.length).join(" ");
      const formData = new FormData();
      formData.append("username", form.username);
      formData.append("email", form.email);
      formData.append("password", form.password);
      formData.append("re_password", form.passwordValidation);
      formData.append("first_name", firstName);
      formData.append("last_name", lastName);
      formData.append("whatsapp_number", form.number);
      axios
        .post(env + "/api/auth/users/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static signIn(env, form) {
    return new Promise((resolve, reject) => {
      axios
        .post(env + "/api/auth/jwt/create/", {
          username: form.username,
          password: form.password,
        })
        .then(({ data }) => {
          resolve(data);
          store.commit("setRefreshToken", {
            value: data.refresh,
          });
          store.commit("setAccessToken", {
            value: data.access,
          });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getAllCandidateScore(env, token, periodId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          env +
            "/api/tahfidz/selections/" +
            periodId +
            "/users/?evaluated=true",
          {
            headers: {
              Authorization: "JWT " + token,
            },
          }
        )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getCandidateData(env, token, periodId) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/tahfidz/selections/" + periodId + "/users/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static sendScoreCandidate(env, token, periodId, form, dataStudent) {
    return new Promise((resolve, reject) => {
      const UserId = store.getters.getUserId;
      const formData = new FormData();
      formData.append("evaluator", UserId);
      formData.append("harakat_mistake", form.harakatMistake);
      formData.append("mad_mistake", form.madMistake);
      formData.append("gunnah_mistake", form.gunnahMistake);
      if (form.isLulus) {
        formData.append("tahsin_level", "4");
      } else {
        formData.append("tahsin_level", form.levelTahsin);
      }
      formData.append("is_passed", form.isLulus);
      formData.append("note", form.note);
      axios
        .post(
          env +
            "/api/selection/evaluation/?id=" +
            dataStudent.id +
            "&period=" +
            periodId,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "JWT " + token,
            },
          }
        )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getScoreCandidate(env, token, periodId, dataStudent) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          env +
            "/api/selection/evaluation/?id=" +
            dataStudent.id +
            "&period=" +
            periodId,
          {
            headers: {
              Authorization: "JWT " + token,
            },
          }
        )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static uploadTransactionProof(env, token, termId, form) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("payment_proof", form.transactionImg);
      axios
        .post(
          process.env.VUE_APP_URL +
            "/api/tahfidz/" +
            termId +
            "/me/payment/upload/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "JWT " + token,
            },
          }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getDataPembayaran(env, token, termId) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/tahfidz/" + termId + "/me/payment/status/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          store.commit("setPaymentStatus", { value: data.payment.status });
          store.commit("setPaymentNominal", { value: data.payment.nominal });
          store.commit("setPaymentId", { value: data.payment.id });
          store.commit("setUrlWhatsappGroup", {
            value: data.payment.whatsapp_link,
          });
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getTeacherAvailableSchedule(env, term, token) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/schedule/student/get/" + term, {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static sendStudentSchedule(env, token, scheduleId) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          env + "/api/schedule/student/put/assign/" + scheduleId,
          {},
          {
            headers: {
              Authorization: "JWT " + token,
            },
          }
        )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static deleteStudentSchedule(env, token, scheduleId) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          env + "/api/schedule/student/put/unassign/" + scheduleId,
          {},
          {
            headers: {
              Authorization: "JWT " + token,
            },
          }
        )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getTeacherSchedule(env, token, term) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/schedule/teacher/get/" + term, {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static sendTeacherSchedule(env, token, term, startDateTime, endDateTime) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("start_datetime", startDateTime);
      formData.append("end_datetime", endDateTime);
      axios
        .post(env + "/api/schedule/teacher/set/" + term, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static updateTeacherSchedule(
    env,
    token,
    scheduleId,
    startDateTime,
    endDateTime
  ) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("start_datetime", startDateTime);
      formData.append("end_datetime", endDateTime);
      axios
        .put(env + "/api/schedule/teacher/put/" + scheduleId, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static deleteTeacherSchedule(env, token, scheduleId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(env + "/api/schedule/teacher/delete/" + scheduleId, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getTeacherReport(env, token, term) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/report/tahfidz/teacher/?term=" + term, {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static sendTeacherReport(env, token, form) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const header = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "JWT " + token,
        },
      };
      formData.append("session", form.session);
      formData.append("juz", form.juz);
      formData.append(
        "surah",
        `${form.fromSurah}:${form.fromAyat}/${form.toSurah}:${form.toAyat}`
      );
      formData.append("score", form.score);
      formData.append("note", form.note);
      let promise;
      if (form.edit) {
        promise = axios.put(
          env + "/api/report/tahfidz/teacher/" + form.id + "/",
          formData,
          header
        );
      } else {
        promise = axios.post(
          env + "/api/report/tahfidz/teacher/",
          formData,
          header
        );
      }
      promise
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static deleteTeacherReport(env, token, form) {
    return new Promise((resolve, reject) => {
      axios
        .delete(env + "/api/report/tahfidz/teacher/" + form.id + "/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getStudentReports(env, term, token) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/report/student/get/" + term, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getRegistrationData(env, token, termId) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/selection/" + termId + "/me/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          store.commit("setRegistrationData", { registrationData: data });
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static uploadSurveyForm(env, token, termId, form) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("teacher_points", form.teacherPoints);
      formData.append("infaq_points", form.infaqPoints);
      formData.append("curriculum_points", form.curriculumPoints);
      formData.append("media_points", form.mediaPoints);
      formData.append("obstacle", form.obstacle);
      formData.append("improvement", form.improvement);
      axios
        .post(
          process.env.VUE_APP_URL +
            "/api/reregistration/survey/post/" +
            termId +
            "/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "JWT " + token,
            },
          }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static uploadDecisionForm(env, token, termId, form) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("ended_term", termId);
      formData.append("status", form.decisionStatus);
      axios
        .post(process.env.VUE_APP_URL + "/api/tahfidz/term-status/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "JWT " + token,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getHasFilledSurvey(env, token, termId) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/reregistration/survey/get/" + termId + "/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          store.commit("setHasFilledSurveyForm", { value: true });
          resolve(data);
        })
        .catch((error) => {
          store.commit("setHasFilledSurveyForm", { value: false });
        });
    });
  }

  static getTermStatus(env, token) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/tahfidz/term-status/latest/", {
          headers: {
            Authorization: "JWT " + token,
          },
        })
        .then(({ data }) => {
          store.commit("setStudentTermStatus", {
            value: data.term_status.status,
          });
          store.commit("setEndedTermId", {
            value: data.term_status.ended_term.id,
          });

          resolve(data);
        })
        .catch((error) => {
          store.commit("setStudentTermStatus", { value: 0 });
        });
    });
  }

  static uploadReferralPayment(env, token, termId, form) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      if (form.infaqOption == 1) {
        formData.append("referral_names", "");
      } else if (form.infaqOption == 2) {
        formData.append("referral_names", form.referralName1);
      } else {
        formData.append(
          "referral_names",
          form.referralName1 + "," + form.referralName2
        );
      }
      axios
        .post(
          process.env.VUE_APP_URL +
            "/api/tahfidz/" +
            termId +
            "/me/payment/referral-names/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "JWT " + token,
            },
          }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }

  static getDownloadReportLink(env, token, fullName) {
    return new Promise((resolve, reject) => {
      axios({
        url: process.env.VUE_APP_URL + "/api/report/me/export",
        method: "GET",
        headers: {
          Authorization: "JWT " + token,
        },
        responseType: "blob",
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "Laporan " + fullName + ".xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    });
  }

  static getAllTerm(env) {
    return new Promise((resolve, reject) => {
      axios
        .get(env + "/api/tahfidz/terms/")
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          errorHandling(error);
        });
    });
  }
}

export default User;
